<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div style="font-size:18px;font-weight:bold;color:black;padding-bottom:10px;border-bottom:1px solid rgb(220,220,220);">我的社交圈</div>
    
    <a-list itemLayout="vertical" size="large" :pagination="pagination" :dataSource="listData">
     <a-list-item slot="renderItem" slot-scope="item, index">
      <a-list-item-meta :description="item.content">
        <span slot="title">{{item.name}}@twitter<span style="display:inline-block;margin-left:25px;color:rgb(175,175,175);font-size:12px;font-weight:normal;">{{ item.created_at}}</span></span>
        <a-avatar slot="avatar" src="http://img.showguide.cn/uploads/try/1565006120twitter.png" />
      </a-list-item-meta>
      </a-list-item>
    </a-list>
  </a-layout-content>
</template>
<script>
import Banner from "./banner";
export default {
  components: { "s-banner": Banner },
  data () {
    return {
      listData:[],
      pagination: {
        onChange: (page,pageSize) => {
          console.log(page);
          console.log(pageSize)
        },
        pageSize: 10,
      },
    }
  },
  created(){
    this.socialList();
  },
  methods:{
      socialList(){
      this.$http
        .post("/getSocialList", {
          token: this.$cookies.get("access-token") || ""
        })
        .then(res => {
            console.log(res)
            this.listData = res.list
        })
      }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
   /deep/ .ant-list-vertical {
    .ant-list-item {
        padding-bottom:0px;
        padding-top: 8px;
        border-bottom: 1px dotted #e8e8e8;
      .ant-list-item-meta-description {
        color: rgb(102,102,102);
        font-size: 14px;
        line-height: 22px;
      }
    }
    .ant-list-item-meta-avatar{
        display: block;
    }
    .ant-list-item-meta-title{
        color: rgb(47,176,236);
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 12px;
    }
}
</style>